import FormController from './form_controller';
import Events from '../classes/Events';
import axios from 'axios';
import lottieWeb from 'lottie-web';
import dividendLoading from 'assets/dividend_loading.json'


const preprocessStripTokenParams = async (scope, params) => {
  const ret_params = {};
  const stripeKey = scope.element.dataset.publishableKey;
  window.Stripe.setPublishableKey(stripeKey);
  const stripeFields = {};
  stripeFields['address_country'] = params['address_country'];
  stripeFields['address_zip'] = params['address_zip'];
  stripeFields['exp_year'] = params['exp_date'].split('/')[1];
  stripeFields['exp_month'] = params['exp_date'].split('/')[0];
  stripeFields['cvc'] = params['cvc'];
  stripeFields['number'] = params['number'];
  stripeFields['name'] = params['name'];
  const stripTokenPromise = new Promise((resolve, reject) => {
    Stripe.card.createToken(stripeFields, (statue, response) => {
      resolve(response.id);
    });
  });
  ret_params['stripe_token'] = await stripTokenPromise;
  return ret_params;
}

const PARAMS_PREPROCESSOR = {
  stripToken: preprocessStripTokenParams
}
class PopupForm extends FormController {
  static targets = [
    'field',
    'close',
    'overlay',
    'overlayIconContainer',
    'errorMessageContainer',
    'errorMessage'
  ]

  static values = { 
    url: String,
    paramWrapper: String,
    preprocessor: String,
  }

  targetNames() {
    return ['field'];
  }

  async submitForm(e) {
    e.preventDefault();
    this.__hideErrorMessage();
    this.__showOverlay();
    if(!this.hasUrlValue) {
      this.element.dispatchEvent(Events.submittedEvent);
      this.__closePopup();
      return;
    }
    try {
      const params = await this.__collectParams();
      const { data } = await axios.post(this.urlValue, params);
      if (data.error) {
        this.__hideOverlay();
        this.__showErrorMessage(data.errorMessage);
      } else {
        this.element.dispatchEvent(Events.submittedEvent);
        this.__closePopup();
      }
    } catch(error) {
      console.log(error);
      let errorMessage = 'Sorry, something went wrong. Please try again later';
      if(error.response){
        errorMessage = error.response.data.error_message;
      }
      this.__hideOverlay();
      this.__showErrorMessage(errorMessage);
    }
  }

  __closePopup() {
    this.__hideOverlay();
    this.closeTarget.click();
  }

  __showOverlay() {
    this.overlayTarget.classList.remove('t-hidden');
    this.overlayTarget.classList.add('t-flex');
    if(!this.overlayIconContainerTarget.childElementCount) {
      lottieWeb.loadAnimation({
        container: this.overlayIconContainerTarget, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: dividendLoading
      });
    }
  }

  __hideOverlay() {
    this.overlayTarget.classList.add('t-hidden');
    this.overlayTarget.classList.remove('t-flex');
  }

  __showErrorMessage(errorMessage) {
    this.errorMessageTarget.innerText = errorMessage || 'Sorry, something went wrong';
    this.errorMessageContainerTarget.classList.remove('t-hidden');
    this.errorMessageContainerTarget.classList.add('t-flex');
  }

  __hideErrorMessage() {
    this.errorMessageContainerTarget.classList.add('t-hidden');
    this.errorMessageContainerTarget.classList.remove('t-flex');
  }

  async __collectParams() {
    let params = this.fieldTargets.reduce((map, e) => {
      map[e.name] = e.value; 
      return map;
    }, {});
    params = await this.__preprocessParams(params);
    if(this.hasParamWrapperValue) {
      params = {
        [this.paramWrapperValue]: params
      }
    }
    return params;
  }

  async __preprocessParams(params) {
    if(!this.hasPreprocessorValue || !PARAMS_PREPROCESSOR[this.preprocessorValue]) return params;
    return await PARAMS_PREPROCESSOR[this.preprocessorValue].call(this, this, params);
  }
}

export default PopupForm;
